// The values the chart draws at one time, for the hover readout (moving averages, VWAP, DSS…). Read
// straight from each line series' points; a series with no point at that time is left out.
// Replaces the OSS per-pane hover boxes, which this app doesn't style.
export function seriesValuesAt(seriesList, t) {
  if (!Number.isFinite(t)) return [];
  return (seriesList || [])
    // showInTooltip: false marks drawing-only lines (trendlines) the pane boxes also left out.
    .filter((s) => s && s.type === 'line' && s.showInTooltip !== false && Array.isArray(s.data))
    .map((s) => {
      const point = s.data.find((p) => p && p.t === t);
      const value = point && Number.isFinite(point.v) ? point.v : null;
      return value === null ? null : { key: s.key, color: s.style?.color ?? s.color ?? null, value };
    })
    .filter(Boolean);
}
